import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@material-ui/core';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { TableActionButton } from '../../../../shared/table-acitoin-button/TableActionButton';
import { getBouquet } from '../../../../utils/cmsUtils';
import { channelNumberSelector } from '../../../cms/cmsSlice';
import './Device-View-Detail.scss';

const ConfigurationsDeviceViewDetail = (props) => {
  const { tabValue, device, hotelId } = props;
  const channelList = useSelector(channelNumberSelector);
  const [channel, setChannel] = useState([]);

  useEffect(() => {
    const getChannelList = async () => {
      const res = await getBouquet(hotelId, device.bouquetId);
      setChannel(res.data?.getBouquet?.livetvs);
    };

    if (device.bouquetId) {
      getChannelList();
    } else {
      setChannel([]);
    }
  }, [device.bouquetId]);

  const getNoChannels = (device) => {
    return device.bouquetId && channelList[device.bouquetId] ? channelList[device.bouquetId] : 0;
  };

  return (
    <div className='row mx-4 mt-4 device-view'>
      {tabValue === 0 && (
        <>
          <div className='row mt-4'>
            <div className='col-md-4'>
              <div className='details-label'>
                {device.area_type === 'room' ? 'Room Number' : 'Location'}
              </div>
              <div className='details-value'>{device.area_type_value}</div>
            </div>
            <div className='col-md-2'>
              <div className='details-label'>Zone</div>
              <div className='details-value'>{device.zone_name}</div>
            </div>
            <div className='col-md-4'>
              <div className='details-label text-center'>Status</div>
              <div
                className={`${
                  device.power_status && device.power_status === 'ON'
                    ? 'device-view-pill-active'
                    : 'device-view-pill-inactive'
                } col-md-3 pill container`}
              >
                <span
                  className={
                    device.power_status && device.power_status === 'ON'
                      ? 'device-view-pill-text-active'
                      : 'device-view-pill-text-inactive'
                  }
                >
                  {device.power_status && device.power_status === 'ON' ? 'ONLINE' : 'OFFLINE'}
                </span>
              </div>
            </div>
          </div>

          <div className='row mt-5'>
            <div className='col-md-4'>
              <div className='details-label'>Bouquet</div>
              <div className='details-value'>{device.bouquetName}</div>
            </div>
            <div className='col-md-4'>
              <div className='details-label'>Last Restart</div>
              <div className='details-value'>
                {device.last_restarted_date ? device.last_restarted_date : '---'}
              </div>
            </div>
          </div>

          <div className='row mt-5'>
            <div className='col-md-4'>
              <div className='details-label'>
                {device.unique_number_type === 'serial_no' ? 'Serial Number' : 'UDID Number'}
              </div>
              <div className='details-value'>{device.uniquenumber_value}</div>
            </div>
          </div>

          <div className='row mt-5'>
            <div className='col-md-4'>
              <div className='details-label'>No of Channels</div>
              <div className='details-value'>{getNoChannels(device)}</div>
            </div>
          </div>

          <div className='row mt-5'>
            <div className='col-md-4'>
              <div className='details-label'>Action</div>
              <div className='details-value'>
                {device.power_status && device.power_status === 'ON' ? (
                  <div className='d-flex align-items-center'>
                    <div className='action-btn-seperator'>
                      <TableActionButton btnClass='red-button' label='Off' />
                    </div>
                    <div>
                      <TableActionButton btnClass='yellow-button' label='Restart' />
                    </div>
                  </div>
                ) : (
                  <div className='d-flex align-items-center'>
                    <div>
                      <TableActionButton btnClass='green-button' label='On' />
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </>
      )}
      {tabValue === 1 && (
        <>
          <TableContainer>
            <Table className='list-table' aria-label='simple table'>
              <TableHead>
                <TableRow>
                  <TableCell className='w-20'>Channel No</TableCell>
                  <TableCell className='w-20'>Name</TableCell>
                  <TableCell className='w-15'>Category</TableCell>
                  <TableCell className='w-20'>Bouquet</TableCell>
                  <TableCell className='w-15'>Code</TableCell>
                  <TableCell className='w-10'>Language</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {channel &&
                  channel.length > 0 &&
                  channel.map((channel, i) => (
                    <TableRow key={i} className='border-white pointer'>
                      <TableCell>{channel.number}</TableCell>
                      <TableCell>{channel.name}</TableCell>
                      <TableCell>{channel.categoryName}</TableCell>
                      <TableCell>{device.bouquetName}</TableCell>
                      <TableCell>{channel.code}</TableCell>
                      <TableCell>{channel.language}</TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
            {(!channel || channel.length === 0) && (
              <div className='d-flex justify-content-center mt-2'>No records found</div>
            )}
          </TableContainer>
        </>
      )}
    </div>
  );
};
export default ConfigurationsDeviceViewDetail;
